
import { Component } from 'react';
import { FormGroup, Label, Input, FormFeedback, } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
/**
* Custom id field
* @author   Stefan Pantic
*/
class CustomID extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        return (
            <FormGroup>
                {
                    this.props.label ?
                        <Label size="sm" className={this.props.error ? "required form-group-label-wrap" : "form-group-label-wrap"}>
                            {this.props.label}{this.props.haveValidation ? <span className="required-label-span">*</span> : null}
                            {
                                this.props.labelInfo ?
                                    <div className='info'>
                                        <Isvg src={infoIcon} />
                                        <div className="info-text">{this.props.labelInfo}</div>
                                    </div>
                                    :
                                    null
                            }
                        </Label>
                        :
                        null
                }
                <Input type='text' size="sm" invalid={this.props.error ? true : false} name={this.props.name} onChange={(e) => {
                    let value = e.target.value.replace(/\s/g, '');
                    if (value.length <= 20)
                        this.props.onChange(value);

                }} value={this.props.value}></Input>
                {this.props.error ? <FormFeedback >{this.props.error}</FormFeedback> : null}
            </FormGroup>
        );
    }
}

export default CustomID;